module.exports = __webpack_public_path__ + "img/download.6bba5d71.png";